import Icon from '@/root/ui/shared/Icon'
import { IconProps } from '@/root/shared-types/ui/ui-types'
import { FC } from 'react'

export const RouteCheckboxWhite: FC<IconProps> = ({ width = 20, height = 20, ...rest }) => (
  <Icon type="RouteCheckbox" width={width} height={height} alt="RouteCheckbox" ignoreRtl {...rest} />
)
